<ng-container *ngIf="jsonControl">
    <app-file-upload #fileUpload *ngIf="!jsonControl.get('backgroundImage').value"
                     [allowedFileExtensions]="['png', 'jpeg', 'jpg', 'gif']"
                     [maxFileCount]="1"
                     [maxSizeInMo]="1"
                     (filedAddedEvent)="onFileAdded($event)"
    ></app-file-upload>
    <ng-container *ngIf="imageUrl">
        <div class="button-bar">
            <div class="cursor-pointer" (click)="removeBackgroundImage()">Changer l'image</div>
        </div>
        <app-drawing-on-image #drawingOnImageComponent *ngIf="imageUrl"
                              [imageUrl]="imageUrl"
                              [options]="options"
                              [drawingData]="drawingData"
                              (changedEvent)="changed($event)">
        </app-drawing-on-image>
    </ng-container>
</ng-container>